/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react/prop-types */
import { useHeaderContext } from '@/sinister/header/contexts/HeaderContext'
import styled from 'styled-components'
import Text from '../../../atomic/Text'

const StyledSecondaryText = styled(Text)`
  font-size: var(--app-header-fontsize-s2, --typography-size-s2);
  font-weight: var(--typography-weight-extrabold);
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  color: var(${({ color }: { color: string }) => color}, var(--color-white));
`

const SecondaryTextLogic = ({
  Wrapper,
  children,
}: {
  Wrapper: any
  children: any
}) => {
  const { colorHeader: color } = useHeaderContext()
  return <Wrapper color={color || 'var(--color-white)'}>{children}</Wrapper>
}

const SecondaryText = ({ children }: { children: any }) => (
  <SecondaryTextLogic Wrapper={StyledSecondaryText}>
    {children}
  </SecondaryTextLogic>
)

export default SecondaryText
